import { render } from "./update.vue?vue&type=template&id=25ac4811"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"

import "./update.vue?vue&type=style&index=0&id=25ac4811&lang=css"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__